import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Vest = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 448 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M207.1 237.4 151.2 69.7C168.6 79.7 192.6 88 224 88s55.4-8.3 72.8-18.3l-70.3 210.9c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V270.5c0-9.5-2.8-18.7-8.1-26.6L392 172.1c-5.3-7.9-8.1-17.1-8.1-26.6V48c0-26.5-21.5-48-48-48h-6.3c-18.6 0-33.9 9.7-43.9 18.8C276.4 27.2 257.2 40 224 40s-52.4-12.8-61.7-21.2C152.3 9.7 137 0 118.3 0H112C85.5 0 64 21.5 64 48v97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5V464c0 26.5 21.5 48 48 48h128c9.9 0 19-3 26.7-8.1-6.8-11.7-10.7-25.4-10.7-39.9V295.8c0-8.6 1.4-17.1 4.1-25.3l11-33.1zm140.2 119.3 48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-294.6 48 48-48c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
  }));
});
Vest.displayName = 'Vest';
export var VestDimensions = {
  height: 512,
  width: 448
};